/**
 * Created by pajicv on 9/29/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import ProjectMain from './ProjectMain';
import { spinnerWhileLoading } from '../../utils/components';

const populates = [{
    child: 'targetGroups',
    root: 'targetGroups'
},{
    child: 'useCases',
    root: 'useCases'
},{
    child: 'members',
    root: 'users'
},{
    child: 'documents',
    root: 'documents'
}];

const enhance = compose(
  connect(
      (state, props) => {
          const { projectId } = props;
          return ({
              project: populate(state.firebase, `projects/${projectId}`, populates),
              auth: state.firebase.auth,
              projectId
          });
      }
  ),
    firebaseConnect((props) => {
        const { projectId } = props;
        return [{ path: `projects/${projectId}`, populates }];
    }),
    spinnerWhileLoading(['project'])
);

export default enhance(ProjectMain);



// WEBPACK FOOTER //
// ./src/routes/ProjectSetup/ProjectMain.enhancer.js